import styled from 'styled-components';
import { color, fontFamily } from '../../design-tokens';

export const Text = styled.span`
  color: ${color.grey};
  font-family: ${fontFamily.regular};
  font-size: ${props => props.fontSize};
  font-weight: 400;
`;
